import { useCertificateQuery } from "@pathwright/graphql-client/src/generated"

function useActiveCertificate() {
  const certificateQuery = useCertificateQuery()
  const certificate = certificateQuery.data?.certificate
  return certificate
}

export default useActiveCertificate
